// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"329186e7","187":"01628e58","228":"3b941bda","538":"eaa7c918","559":"dcf5653a","590":"12c24e7d","656":"b8a394af","695":"081a3a56","846":"af8ab956"}[chunkId] + ".js";
};